__turbopack_context__.v({
  "card": "Card-module-scss-module__etkqra__card",
  "tooltip": "Card-module-scss-module__etkqra__tooltip",
});
